import React from 'react'
import { getChartColor } from 'src/Libs/system-charts/shared'

export interface WeatherBreakthroughDotProps {
  cx?: number
  cy?: number
  payload?: {
    WeatherBreakthrough: boolean
  }
}

/**
 * A dot-svg to use as a marker, wherever the weather breakthrough is reached
 * @param WeatherBreakthroughDotProps with placement and payload (set by recharts)
 * @returns a colored rectangle as a svg-component
 */
export const WeatherBreakthroughDot: React.FC<WeatherBreakthroughDotProps> = ({ cx, cy, payload }) => {
  if (payload?.WeatherBreakthrough && cx && cy) {
    return (
      <svg width="16" height="16" x={cx - 8} y={cy - 8} viewBox="0 0 16 16" fill="none">
        <rect x="1" y="1" width="14" height="14" rx="3" fill={getChartColor('WeatherBreakthrough')} stroke="white" strokeWidth="2" />
      </svg>
    )
  }

  return null
}
